module.exports = __webpack_public_path__ + "media/images/signup-chance-perry-5766eda750954640c96aaa14662e0748.jpg";